export default "__VITE_ASSET__Cl_$gZDZ__"